import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUIX from 'vue-element-ui-x';

import codeMix from "./mixins/codeMix.js";

// 导入 SVG 图标
import './utils/svg-icons';
// 导入并全局注册 SvgIcon 组件
import SvgIcon from './DifyChat/components/SvgIcon.vue';
Vue.component('SvgIcon', SvgIcon);

// 引入 Element UI
Vue.use(ElementUI);

// 引入 Element-UI-X
Vue.use(ElementUIX);

Vue.mixin(codeMix);

import tool from "@/utils/encrypt";

Vue.prototype.$tool = tool;

Vue.config.productionTip = false;

Vue.use(Antd);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
